import * as React from 'react';
import { PopupOk } from './PopupOk';
import { LogoutPopupService } from "../services/LogoutPopupService";

export interface LogoutPopupProps {
  title : string;
  description: string;
}

export const LogoutPopup = (props : LogoutPopupProps) => {
  return <PopupOk message={props.title}
    okButtonText = "OK"
    okButtonCssContainerName = "form__popup-ok-loggedout"
    withIcon = "icon-clock"
    btnCssClass = "btn-primary"
    description = {props.description}
    onPopupOK={() => {
      location.href = "/mijn-fnv";        
    }}></PopupOk>;
};